import React, { useState } from "react";
import { Box, Radio, RadioOption, Separator, Text } from "@showitinc/showit-wc";
import ButtonBar from "../SetupButtonBar";
import ViewPanel from "../ViewPanel";
import Constants from "../Constants";
import { getBlogType } from "../../../hooks/query/useAccount";
import AppConstants from "../../../constants/AppConstants";

function SetupViewChooseSetupType({ blogSetup, actions }) {
  const [path, setPath] = useState(blogSetup.path || Constants.PATH_NEW);
  const blogType = getBlogType();
  const isBasicBlog = blogType === AppConstants.BLOG_TYPE_BASIC;

  // When path changes, notify parent component
  React.useEffect(() => {
    if (path !== blogSetup.path) {
      actions.choosePath({ path });
    }
  }, [path]);

  const inputStyle = {
    cursor: isBasicBlog ? "default" : "pointer",
    opacity: isBasicBlog ? 0.45 : 1,
  };

  return (
    <ViewPanel>
      {{
        content: (
          <>
            <Text variant="heading-2" variantStyle="strong">
              Blog Setup Type
            </Text>
            <Separator />
            <div>
              <Text>Would you like to set up a new blog or migrate your existing blog?</Text>
              <Box my="3">
                <Radio>
                  <RadioOption
                    name="blog_setup_type"
                    value="new"
                    label="Set up New Blog"
                    checked={Constants.PATH_NEW === path}
                    onSIChange={() => setPath(Constants.PATH_NEW)}
                  />
                  {!isBasicBlog && (
                    <RadioOption
                      labelStyle={inputStyle}
                      inputStyle={inputStyle}
                      disabled={isBasicBlog}
                      name="blog_setup_type"
                      value="migrate"
                      label="Migrate Existing Blog"
                      checked={Constants.PATH_MIGRATION === path}
                      onSIChange={() => setPath(Constants.PATH_MIGRATION)}
                    />
                  )}
                </Radio>
              </Box>
              {isBasicBlog && (
                <p className="muted" style={{ marginTop: ".25rem" }}>
                  Migrations are only available for Advanced Blog subscriptions
                </p>
              )}
            </div>
          </>
        ),
        actions: (
          <ButtonBar
            onForward={() => actions.choosePath({ path })}
            allowForward={path !== undefined}
            forwardBtnText="Next"
          />
        ),
      }}
    </ViewPanel>
  );
}

export default SetupViewChooseSetupType;
